import { render, staticRenderFns } from "./Funding-Organisation-History.vue?vue&type=template&id=6b35da6a"
import script from "./Funding-Organisation-History.vue?vue&type=script&lang=js"
export * from "./Funding-Organisation-History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports